const VERSION = '2.6.6';
export function getVersionString() {
    return VERSION;
}
